import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class reporteCuentaCobrarService {

    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/reporte-cobrar/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/reporte-cobrar/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/reporte-cobrar/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


}

export default new reporteCuentaCobrarService();